/* 🤖 this file was generated by svg-to-ts */
export const siriusEnvelopeOpen: {
  name: 'envelope_open';
  data: string;
} = {
  name: 'envelope_open',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.416 2.376a.75.75 0 0 0-.832 0l-8.985 5.99a.746.746 0 0 0-.349.633v9.751a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V9.013a.747.747 0 0 0-.351-.648l-8.983-5.989Zm7.263 6.645L12 3.9l-7.68 5.12L10.6 13.5h2.8l6.28-4.48ZM3.75 10.456v7.546l5.314-3.755-5.314-3.79ZM10.598 15 5.29 18.75h13.42L13.402 15h-2.804Zm4.338-.753 5.314 3.755v-7.546l-5.314 3.791Z" fill="currentColor"/></svg>`
};
